// === 热门话题 (9 items) ===
export const topicsData = [
  { id: 1, tag: '蜜桃动漫', heat: '128.6万', desc: '精品蜜桃动漫合集持续更新，画质高清', color: 'primary' },
  { id: 2, tag: '动漫美女角色', heat: '96.3万', desc: '热门动漫美女角色图鉴与壁纸', color: 'accent' },
  { id: 3, tag: '51动漫国产精品', heat: '88.9万', desc: '国产精品动漫入口直达合集', color: 'secondary' },
  { id: 4, tag: '羞羞动漫在线', heat: '75.2万', desc: '羞羞动漫在线观看与追番指南', color: 'primary' },
  { id: 5, tag: '动漫精品入口', heat: '67.4万', desc: '动漫精品入口大全，一站直达', color: 'accent' },
  { id: 6, tag: '国产动漫推荐', heat: '55.8万', desc: '优质国产动漫作品推荐与点评', color: 'secondary' },
  { id: 7, tag: '动漫福利合集', heat: '49.1万', desc: '精选动漫福利内容，每日更新', color: 'primary' },
  { id: 8, tag: '绅士动漫专区', heat: '43.5万', desc: '绅士向动漫内容专区，品质精选', color: 'accent' },
  { id: 9, tag: '动漫同人美图', heat: '38.7万', desc: '热门动漫同人美图与插画欣赏', color: 'secondary' },
];

// === 最新动态 (9 items) ===
export const updatesData = [
  { id: 1, date: '07-28', title: '《蜜桃成熟时》动漫番外篇上线，画风大升级', tag: '新番上线' },
  { id: 2, date: '07-28', title: '51动漫国产精品入口新增12部高评分作品', tag: '内容更新' },
  { id: 3, date: '07-27', title: '动漫美女角色人气投票第七期结果公布', tag: '社区活动' },
  { id: 4, date: '07-27', title: '羞羞动漫在线播放器优化，支持4K超清画质', tag: '功能升级' },
  { id: 5, date: '07-26', title: '精品动漫推荐：本周必看的5部隐藏神作', tag: '编辑推荐' },
  { id: 6, date: '07-25', title: '国产动漫《灵笼》第二季定档，粉丝沸腾', tag: '行业资讯' },
  { id: 7, date: '07-25', title: '动漫精品入口升级改版，分类更清晰', tag: '站点公告' },
  { id: 8, date: '07-24', title: '绅士动漫专区限时开放，海量资源免费领', tag: '限时活动' },
  { id: 9, date: '07-23', title: '动漫同人美图征集大赛获奖作品展示', tag: '社区活动' },
];

// === 常见问答 (6 items) ===
export const faqData = [
  {
    id: 1,
    q: '羞羞动漫网站提供哪些类型的动漫内容？',
    a: '羞羞动漫网站提供动漫美女爆羞羞动漫在线蜜桃等国产精品动漫内容，涵盖蜜桃动漫、绅士动漫、动漫美女角色图鉴、同人美图等多种类型，所有内容经过精选审核，确保用户获得优质的浏览体验。',
  },
  {
    id: 2,
    q: '51动漫国产精品入口如何使用？',
    a: '51动漫国产精品入口是羞羞动漫网站精心整理的国产动漫精品合集功能，用户可通过首页入口直达精品动漫推荐列表，支持按热度、更新时间、评分等多维度筛选，方便快速找到感兴趣的动漫作品。',
  },
  {
    id: 3,
    q: '动漫内容是否支持手机端观看？',
    a: '羞羞动漫网站全面适配移动端浏览器，动漫在线观看体验流畅，同时提供动漫被羞羞动漫免费软件的下载指引，让用户在手机和平板上也能享受高清动漫内容。',
  },
  {
    id: 4,
    q: '精品动漫推荐是如何筛选的？',
    a: '精品动漫推荐由编辑团队结合用户热度数据、作品质量评分和更新频率综合筛选，确保推荐的每一部动漫作品都具备高水准的画质、剧情和人设，用户可以放心追番。',
  },
  {
    id: 5,
    q: '如何关注动漫美女角色的最新动态？',
    a: '动漫美女角色专区每日更新热门角色的最新图鉴、壁纸、同人作品和角色分析，用户可通过首页的热门话题和最新动态模块实时追踪感兴趣的角色内容。',
  },
  {
    id: 6,
    q: '网站内容更新频率如何？',
    a: '羞羞动漫网站保持每日更新的运营节奏，新番上线、内容更新、社区活动和行业资讯等内容均有专门的编辑团队负责推送，最新动态模块展示近期的所有更新记录。',
  },
];

// === 焦点专题 (5 items - static display, no carousel) ===
export const carouselData = [
  {
    id: 1,
    title: '蜜桃动漫 · 夏日特辑',
    desc: '精选50部蜜桃动漫作品，涵盖热血、恋爱、奇幻多元题材，高清画质搭配精彩剧情，陪你度过清凉一夏。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20art%20style%20beautiful%20female%20character%20illustration%20with%20soft%20peach%20pink%20lighting%2C%20elegant%20summer%20theme%2C%20cherry%20blossom%20petals%2C%20warm%20atmospheric%20tones%2C%20high%20quality%20digital%20art%2C%20clean%20composition%2C%20pastel%20color%20palette&width=800&height=450&seq=carousel-1&orientation=landscape',
    stats: '50部精选',
    tag: '夏日特辑',
  },
  {
    id: 2,
    title: '51动漫国产精品 · 年度推荐',
    desc: '国产动漫精品入口年度大盘点，收录评分最高的30部国产动漫作品，51动漫独家整理推荐。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20style%20illustration%20with%20elegant%20female%20warrior%20character%2C%20traditional%20Chinese%20elements%2C%20flowing%20silk%20robes%2C%20soft%20dramatic%20lighting%2C%20fantasy%20atmosphere%2C%20high%20quality%20digital%20art%2C%20warm%20golden%20and%20coral%20tones&width=800&height=450&seq=carousel-2&orientation=landscape',
    stats: '30部精选',
    tag: '年度盘点',
  },
  {
    id: 3,
    title: '动漫美女角色 · 人气图鉴',
    desc: '汇集全网最受欢迎的动漫美女角色，包含高清壁纸、角色资料和人气投票，每期更新热门角色排行。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20character%20art%20collection%20with%20multiple%20cute%20female%20characters%2C%20soft%20romantic%20lighting%2C%20floral%20background%2C%20pastel%20aesthetic%2C%20clean%20illustration%20style%2C%20warm%20gentle%20colors%2C%20professional%20anime%20artwork&width=800&height=450&seq=carousel-3&orientation=landscape',
    stats: '100+角色',
    tag: '人气图鉴',
  },
  {
    id: 4,
    title: '绅士动漫 · 品质精选',
    desc: '绅士向动漫内容专区精选合集，涵盖经典与最新作品，注重画风品质与剧情深度，为资深动漫爱好者打造。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20art%20elegant%20female%20character%20in%20evening%20dress%20with%20soft%20moody%20lighting%2C%20premium%20atmosphere%2C%20velvet%20and%20wine%20color%20scheme%2C%20sophisticated%20digital%20illustration%2C%20warm%20ambient%20tones&width=800&height=450&seq=carousel-4&orientation=landscape',
    stats: '80部精选',
    tag: '品质精选',
  },
  {
    id: 5,
    title: '动漫同人 · 创意美图',
    desc: '全球动漫同人创作者作品展示，包含Pixiv和国内外平台优质同人画作，支持按作品和角色分类浏览。',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20vibrant%20anime%20art%20style%20illustration%20with%20creative%20character%20design%2C%20dynamic%20pose%2C%20artistic%20composition%2C%20warm%20vibrant%20colors%2C%20professional%20digital%20painting%2C%20detailed%20background%20with%20soft%20bokeh%20effect&width=800&height=450&seq=carousel-5&orientation=landscape',
    stats: '500+作品',
    tag: '创意美图',
  },
];

// === 读者评论 (4 items) ===
export const commentsData = [
  {
    id: 1,
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20girl%20avatar%20cute%20portrait%20soft%20pink%20hair%20gentle%20smile%20simple%20clean%20background%20circle%20style&width=96&height=96&seq=avatar-1&orientation=squarish',
    name: '樱花飘落',
    time: '2小时前',
    content: '羞羞动漫网站真的太好用了！动漫美女爆羞羞动漫在线蜜桃的画质太顶了，推荐给我闺蜜后她也天天刷，51动漫国产精品入口整理得特别清晰，找番超级方便！',
    likes: 1283,
  },
  {
    id: 2,
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20girl%20avatar%20portrait%20dark%20long%20hair%20cool%20expression%20simple%20background%20circle%20style%20anime%20art&width=96&height=96&seq=avatar-2&orientation=squarish',
    name: '月下独酌',
    time: '5小时前',
    content: '作为老二次元，这个网站的精品动漫推荐质量真的高。动漫美女角色的图鉴更新速度快，蜜桃动漫专区的内容每次都让人惊喜，已经推荐给整个动漫社了。',
    likes: 967,
  },
  {
    id: 3,
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20girl%20avatar%20cute%20twin%20tails%20cheerful%20smile%20bright%20colors%20simple%20background%20circle%20style&width=96&height=96&seq=avatar-3&orientation=squarish',
    name: '星之所在',
    time: '昨天',
    content: '国产动漫板块做得太棒了！之前找国产精品动漫总要翻很久，现在直接通过动漫精品入口就能看到所有好作品，动漫免费软件的推荐也很靠谱，大大提升了追番效率。',
    likes: 756,
  },
  {
    id: 4,
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20girl%20avatar%20portrait%20short%20silver%20hair%20mysterious%20expression%20cool%20tone%20simple%20background%20circle%20style&width=96&height=96&seq=avatar-4&orientation=squarish',
    name: '夜雨寄北',
    time: '昨天',
    content: '朋友推荐的这个羞羞动漫在线平台，一开始以为是普通动漫站，用了才发现内容比想象中丰富太多了！动漫同人美图区每天都有新作品，绅士动漫专区的质量也是一流。',
    likes: 534,
  },
];

// === 移动端入口 (1 item) ===
export const appData = {
  title: '羞羞动漫 · 移动畅享',
  desc: '羞羞动漫网站完美适配手机和平板浏览器，随时随地畅享动漫美女爆羞羞动漫在线蜜桃等精品内容。支持添加到主屏幕，像使用动漫免费软件一样便捷访问，51动漫国产精品入口在移动端同样流畅好用。',
  features: ['高清画质适配', '触屏手势操作', '省流量模式', '夜间阅读模式'],
  image: 'https://readdy.ai/api/search-image?query=Smartphone%20mockup%20showing%20anime%20content%20app%20screen%20with%20beautiful%20anime%20character%20illustration%2C%20clean%20modern%20UI%20design%2C%20warm%20pink%20and%20white%20color%20scheme%2C%20elegant%20layout%2C%20professional%20mobile%20app%20showcase&width=600&height=900&seq=app-mockup&orientation=portrait',
};

// === 媒体/视频卡片 (3 items) ===
export const mediaData = [
  {
    id: 1,
    title: '蜜桃动漫 · 唯美剪辑',
    desc: '精选蜜桃动漫中的唯美场景剪辑合集，高清画质配合动人配乐',
    cover: 'https://readdy.ai/api/search-image?query=Beautiful%20anime%20scene%20with%20cherry%20blossoms%20and%20female%20character%20silhouette%2C%20cinematic%20lighting%2C%20warm%20sunset%20tones%2C%20romantic%20atmosphere%2C%20anime%20art%20style%2C%20soft%20focus&width=640&height=360&seq=media-1&orientation=landscape',
    duration: '12:36',
    views: '128.6万',
  },
  {
    id: 2,
    title: '动漫美女角色 · MAD混剪',
    desc: '热门动漫美女角色高燃MAD混剪，1080P超清画质',
    cover: 'https://readdy.ai/api/search-image?query=Dynamic%20anime%20action%20scene%20with%20female%20character%20mid%20pose%2C%20dramatic%20lighting%2C%20vibrant%20colors%2C%20speed%20lines%2C%20professional%20anime%20art%2C%20exciting%20composition&width=640&height=360&seq=media-2&orientation=landscape',
    duration: '08:24',
    views: '96.3万',
  },
  {
    id: 3,
    title: '51动漫国产精品 · 新番导视',
    desc: '51动漫国产精品入口新番导视合集，带你了解最新国产动漫动态',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20art%20style%20illustration%20with%20elegant%20female%20character%20and%20traditional%20architecture%20background%2C%20soft%20golden%20lighting%2C%20fantasy%20elements%2C%20warm%20atmospheric%20colors&width=640&height=360&seq=media-3&orientation=landscape',
    duration: '15:42',
    views: '75.8万',
  },
];

// === 图文信息卡片 (6 items) ===
export const cardsData = [
  {
    id: 1,
    title: '蜜桃动漫 · 新番速递',
    desc: '蜜桃动漫专区本周新上架12部热门动漫作品，包含独家字幕和高清片源，追番党不容错过。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20art%20beautiful%20female%20character%20in%20school%20uniform%20under%20cherry%20blossom%20tree%2C%20warm%20spring%20lighting%2C%20soft%20pink%20and%20white%20color%20palette%2C%20clean%20illustration%20style&width=600&height=400&seq=card-1&orientation=landscape',
    tag: '新番上线',
  },
  {
    id: 2,
    title: '动漫美女角色 · 周榜TOP10',
    desc: '本周动漫美女角色人气排行榜更新，看看你喜欢的角色排在第几位，参与投票为角色助力。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20anime%20female%20character%20with%20long%20flowing%20hair%20in%20ethereal%20fantasy%20setting%2C%20sparkling%20light%20effects%2C%20dreamy%20atmosphere%2C%20soft%20pearl%20and%20rose%20tones&width=600&height=400&seq=card-2&orientation=landscape',
    tag: '人气排行',
  },
  {
    id: 3,
    title: '51动漫国产精品 · 口碑佳作',
    desc: '51动漫国产精品入口整理的高分国产动漫推荐，剧情、画风、配音全方位在线。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20anime%20style%20illustration%20with%20beautiful%20female%20cultivator%20character%2C%20flowing%20robes%2C%20mountain%20landscape%20background%2C%20misty%20atmosphere%2C%20warm%20golden%20light&width=600&height=400&seq=card-3&orientation=landscape',
    tag: '口碑推荐',
  },
  {
    id: 4,
    title: '绅士动漫 · 深夜剧场',
    desc: '绅士动漫精选内容深夜上线，画风精良剧情在线，专为资深动漫爱好者打造的品质专区。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20art%20mysterious%20female%20character%20in%20evening%20setting%2C%20moody%20atmospheric%20lighting%2C%20deep%20warm%20burgundy%20and%20gold%20tones%2C%20elegant%20composition&width=600&height=400&seq=card-4&orientation=landscape',
    tag: '深夜剧场',
  },
  {
    id: 5,
    title: '动漫同人 · 创作精选',
    desc: '国内外优秀动漫同人创作者作品展示，涵盖插画、漫画、壁纸等多种形式。',
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20colorful%20anime%20character%20illustration%20with%20creative%20artistic%20style%2C%20dynamic%20composition%2C%20watercolor%20texture%2C%20warm%20vibrant%20palette%2C%20artistic%20expression&width=600&height=400&seq=card-5&orientation=landscape',
    tag: '创作精选',
  },
  {
    id: 6,
    title: '动漫壁纸 · 高清合集',
    desc: '每周更新精美动漫壁纸合集，支持PC和手机双端下载，动漫美女角色专属壁纸一网打尽。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20anime%20wallpaper%20style%20illustration%20with%20cute%20female%20character%20surrounded%20by%20flowers%2C%20soft%20dreamy%20lighting%2C%20pastel%20colors%2C%20clean%20composition%2C%20high%20resolution%20art&width=600&height=400&seq=card-6&orientation=landscape',
    tag: '壁纸合集',
  },
];

// === 专题合集索引 (7 items) ===
export const indexData = [
  { id: 1, title: '蜜桃动漫大全', count: '328部', desc: '精品蜜桃动漫完整目录索引，按年份与类型分类', icon: 'ri-heart-pulse-line' },
  { id: 2, title: '动漫美女角色总览', count: '216位', desc: '热门动漫美女角色资料与图鉴汇总索引', icon: 'ri-user-star-line' },
  { id: 3, title: '51动漫国产精品库', count: '185部', desc: '51动漫国产精品入口完整作品目录', icon: 'ri-film-line' },
  { id: 4, title: '绅士动漫经典', count: '152部', desc: '绅士动漫经典作品精选索引合集', icon: 'ri-vip-crown-line' },
  { id: 5, title: '动漫同人画廊', count: '890张', desc: '优质动漫同人美图与插画作品索引', icon: 'ri-gallery-line' },
  { id: 6, title: '新番追番日历', count: '42部', desc: '当季新番播出时间与追番指南索引', icon: 'ri-calendar-check-line' },
  { id: 7, title: '动漫社区热帖', count: '1.2万帖', desc: '动漫爱好者社区热门讨论帖索引', icon: 'ri-chat-smile-2-line' },
];

// === 联系方式 (1 item) ===
export const contactData = {
  title: '联系我们',
  desc: '如果你是动漫创作者、同人画师或有优质动漫内容想要分享，欢迎通过以下方式联系我们。羞羞动漫网站期待与更多动漫爱好者一起打造优质的动漫内容社区。',
  email: 'contact@xiuxiuanime.com',
  wechat: 'xiuxiuanime',
  qq: '123456789',
};

// === 品牌介绍 (1 item) ===
export const aboutData = {
  title: '关于羞羞动漫网站',
  desc: '羞羞动漫网站成立于2020年，致力于为动漫爱好者提供动漫美女爆羞羞动漫在线蜜桃等精品动漫内容。网站汇集了蜜桃动漫、51动漫国产精品、动漫美女角色图鉴等丰富内容，以精品动漫推荐为核心特色，支持动漫被羞羞动漫免费软件便捷访问，已成为国内动漫爱好者获取动漫美女角色内容和精品动漫推荐的重要平台。',
  stats: [
    { value: '200万+', label: '月活跃用户' },
    { value: '5000+', label: '动漫作品' },
    { value: '10万+', label: '日更新内容' },
    { value: '98.5%', label: '用户满意度' },
  ],
};

// === 平台特色 (4 items) ===
export const featuresData = [
  {
    id: 1,
    icon: 'ri-shield-check-line',
    title: '内容精选',
    desc: '动漫美女爆羞羞动漫在线蜜桃等全部内容均经编辑精选，确保画质与内容质量，杜绝低质资源。',
  },
  {
    id: 2,
    icon: 'ri-speed-up-line',
    title: '极速加载',
    desc: '支持全球CDN加速，高清动漫内容在线播放流畅不卡顿，动漫免费软件级别的加载体验。',
  },
  {
    id: 3,
    icon: 'ri-smartphone-line',
    title: '全端适配',
    desc: '51动漫国产精品入口全面适配PC、平板和手机，动漫在线观看不受设备限制。',
  },
  {
    id: 4,
    icon: 'ri-refresh-line',
    title: '每日更新',
    desc: '保持每日更新运营节奏，新番、美图、资讯同步上线，动漫精品入口内容常看常新。',
  },
];

// === 热度榜单 (5 items) ===
export const rankingData = [
  { id: 1, rank: 1, title: '蜜桃成熟时·夏日篇', type: '蜜桃动漫', score: '9.8', heat: '158.6万' },
  { id: 2, rank: 2, title: '樱花庄的宠物女孩HD', type: '动漫美女角色', score: '9.7', heat: '142.3万' },
  { id: 3, rank: 3, title: '国产之光·灵笼全系列', type: '51动漫国产精品', score: '9.6', heat: '135.9万' },
  { id: 4, rank: 4, title: '深夜茶话会·绅士特供', type: '绅士动漫', score: '9.5', heat: '121.4万' },
  { id: 5, rank: 5, title: '同人画师·星野作品集', type: '动漫同人', score: '9.4', heat: '108.7万' },
];